export default "__VITE_ASSET__5b9072a5__"